import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { TemplateRef } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SidenavContentService {
  private sidenavContentSource = new BehaviorSubject<TemplateRef<any> | null>(null);
  private closeSidenavSubject = new BehaviorSubject<boolean>(false);

  // New: Support for detail view sidenav toggling
  private toggleSidenavSubject = new Subject<void>();
  private detailSidenavToggleFn: (() => void) | null = null;

  // Track when a detail sidenav is active (to hide the main sidenav)
  private detailSidenavActiveSubject = new BehaviorSubject<boolean>(false);
  detailSidenavActive$ = this.detailSidenavActiveSubject.asObservable();

  currentSidenavContent = this.sidenavContentSource.asObservable();
  closeSidenav$ = this.closeSidenavSubject.asObservable();
  toggleSidenav$ = this.toggleSidenavSubject.asObservable();

  constructor() { }

  updateSidenavContent(template: TemplateRef<any> | null) {
    this.sidenavContentSource.next(template);
  }

  requestSidenavClose() {
    this.closeSidenavSubject.next(true);
  }

  /**
   * Request a sidenav toggle. This will either:
   * - Toggle the detail view's sidenav if one is registered
   * - Or trigger the main sidenav toggle in SecureHomeComponent
   */
  requestSidenavToggle() {
    if (this.detailSidenavToggleFn) {
      // Detail view has registered its own toggle function
      this.detailSidenavToggleFn();
    } else {
      // No detail view registered, emit event for main sidenav
      this.toggleSidenavSubject.next();
    }
  }

  /**
   * Register a detail view's sidenav toggle function
   * Call this in ngOnInit of detail components like ContractFormComponent
   * This also notifies the main sidenav to hide itself
   */
  registerDetailSidenavToggle(toggleFn: () => void) {
    this.detailSidenavToggleFn = toggleFn;
    this.detailSidenavActiveSubject.next(true);
  }

  /**
   * Unregister the detail view's sidenav toggle function
   * Call this in ngOnDestroy of detail components
   * This also notifies the main sidenav it can show again
   */
  unregisterDetailSidenavToggle() {
    this.detailSidenavToggleFn = null;
    this.detailSidenavActiveSubject.next(false);
  }

  /**
   * Check if a detail sidenav is currently registered
   * Used by SecureHomeComponent to know whether to show/hide its sidenav
   */
  hasDetailSidenav(): boolean {
    return this.detailSidenavToggleFn !== null;
  }
}